import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import salesReport from '../../assets/images/SalesReport.jpg';
import invoiceSample from '../../assets/images/invoice-sample.jpg';
import posDashboard from '../../assets/images/pos-dashboard.jpg';
import shapeSix from '../../assets/images/shape/shape-6.png';
import shapeSeven from '../../assets/images/shape/shape-7.png';
import shapeEight from '../../assets/images/shape/shape-8.png';

function FeaturesHomeOne({ className }) {
    const [tab, setTab] = useState('setting');
    const handleClick = (e, value) => {
        e.preventDefault();
        setTab(value);
    };
    return (
        <section className={`appie-features-area pt-100 pb-100 ${className}`} id="features">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-3">
                        <div className="appie-features-tabs-btn">
                            <div
                                className="nav flex-column nav-pills"
                                id="v-pills-tab"
                                role="tablist"
                                aria-orientation="vertical"
                            >
                                <a
                                    onClick={(e) => handleClick(e, 'setting')}
                                    className={`nav-link ${tab === 'setting' ? 'active' : ''}`}
                                    id="v-pills-home-tab"
                                    data-toggle="pill"
                                    href="#v-pills-home"
                                    role="tab"
                                    aria-controls="v-pills-home"
                                    aria-selected="true"
                                >
                                    <i className="fas fa-file" /> Professional documents
                                </a>

                                <a
                                    onClick={(e) => handleClick(e, 'notice')}
                                    className={`nav-link ${tab === 'notice' ? 'active' : ''}`}
                                    id="v-pills-messages-tab"
                                    data-toggle="pill"
                                    href="#v-pills-messages"
                                    role="tab"
                                    aria-controls="v-pills-messages"
                                    aria-selected="false"
                                >
                                    <i className="fas fa-utensils"></i> Dashboards
                                </a>
                                <a
                                    onClick={(e) => handleClick(e, 'app')}
                                    className={`nav-link ${tab === 'app' ? 'active' : ''}`}
                                    id="v-pills-settings-tab"
                                    data-toggle="pill"
                                    href="#v-pills-settings"
                                    role="tab"
                                    aria-controls="v-pills-settings"
                                    aria-selected="false"
                                >
                                    <i className="fas fa-lock" /> Reports
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-9">
                        <div className="tab-content" id="v-pills-tabContent">
                            <div
                                className={`${
                                    tab === 'setting' ? 'show active' : ''
                                } tab-pane fade`}
                                id="v-pills-home"
                                role="tabpanel"
                                aria-labelledby="v-pills-home-tab"
                            >
                                <div className="row align-items-center">
                                    <div className="col-lg-6">
                                        <div
                                            className="appie-features-thumb text-center wow animated fadeInUp"
                                            data-wow-duration="2000ms"
                                            data-wow-delay="200ms"
                                        >
                                            <img
                                                loading="lazy"
                                                className="thumbnail"
                                                src={invoiceSample}
                                                alt="Invoice Sample"
                                                title="Invoice Sample"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div
                                            className="appie-features-content wow animated fadeInRight"
                                            data-wow-duration="2000ms"
                                            data-wow-delay="600ms"
                                        >
                                            <span>Create invoices in a single click</span>
                                            <h3 className="title">Invoicing made easy</h3>
                                            <p>
                                                A perfect solution for businesses of all sizes, from
                                                freelancers to large corporations, who need a
                                                simple, reliable, and secure way to create and send
                                                invoices to their clients.
                                                <br /> Additionally, it's cloud-based, so you can
                                                access it from anywhere, anytime, on any device
                                            </p>

                                            <Link className="main-btn" to="/apps/backoffice">
                                                Learn More
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className={`${tab === 'notice' ? 'show active' : ''} tab-pane fade`}
                                id="v-pills-messages"
                                role="tabpanel"
                                aria-labelledby="v-pills-messages-tab"
                            >
                                <div className="row align-items-center">
                                    <div className="col-lg-8">
                                        <div
                                            className="appie-features-thumb text-center animated fadeInUp"
                                            data-wow-duration="2000ms"
                                            data-wow-delay="200ms"
                                        >
                                            <img
                                                loading="lazy"
                                                src={posDashboard}
                                                alt="Dashboards"
                                                title="Dashboards"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div
                                            className="appie-features-content animated fadeInRight"
                                            data-wow-duration="2000ms"
                                            data-wow-delay="600ms"
                                        >
                                            <span>Real-time view of your financial data</span>
                                            <h3 className="title">Dashboards</h3>
                                            <p>
                                                Our dashboards, you can easily track your business
                                                performance, identify areas for improvement, and
                                                make informed decisions to grow your business.
                                            </p>
                                            <a className="main-btn" href="/apps">
                                                Learn More
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={`${tab === 'app' ? 'show active' : ''} tab-pane fade`}
                                id="v-pills-settings"
                                role="tabpanel"
                                aria-labelledby="v-pills-settings-tab"
                            >
                                <div className="row align-items-center">
                                    <div className="col-lg-7">
                                        <div
                                            className="appie-features-thumb text-center animated fadeInUp"
                                            data-wow-duration="2000ms"
                                            data-wow-delay="200ms"
                                        >
                                            <img loading="lazy" src={salesReport} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-lg-5">
                                        <div
                                            className="appie-features-content animated fadeInRight"
                                            data-wow-duration="2000ms"
                                            data-wow-delay="600ms"
                                        >
                                            <span>Informative reports</span>
                                            <h3 className="title">Reports</h3>
                                            <p>
                                                We are confident that our app's reports can help you
                                                gain valuable insights into your business and make
                                                informed decisions to drive growth. We would love to
                                                offer you a free trial to experience our app for
                                                yourself.
                                            </p>
                                            <a className="main-btn" href="/apps">
                                                Learn More
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="features-shape-1">
                <img loading="lazy" src={shapeSix} alt="" />
            </div>
            <div className="features-shape-2">
                <img loading="lazy" src={shapeSeven} alt="" />
            </div>
            <div className="features-shape-3">
                <img loading="lazy" src={shapeEight} alt="" />
            </div>
        </section>
    );
}

export default FeaturesHomeOne;
